import { Link } from "react-router-dom";
import NflUtil from "../../util/nflUtil";
import React from "react";
import moment from "moment";

export function getPlayerName(player, options = {}) {
  if (!player) return null;

  const getNameShort = (player) => {
    let nameShort;
    if (player.pos === "DEF") {
      nameShort =
        player.firstName === "Washington" ? player.firstName : player.lastName;
    } else {
      nameShort = player.firstName.charAt(0) + "." + player.lastName;
    }
    return nameShort;
  };

  const getNameFull = (player) => {
    return `${player.firstName} ${player.lastName}`;
  };

  const getNflTeamAbbr = (player) => {
    if (!player.nflTeamAbbr || player.pos === "DEF") return null;
    return NflUtil.formatNflTeamAbbr(player.nflTeamAbbr);
  };

  let fullName = getNameFull(player);
  let name = fullName;
  if (options.short) {
    name = <span title={fullName}>{getNameShort(player)}</span>;
  }
  const pos = options.pos && player.pos ? player.pos : null;
  const nfl = options.nfl ? getNflTeamAbbr(player) : null;
  const injury = options.injury ? getPlayerInjuryCross(player) : null;
  const bye = options.bye ? (
    <span title={"Bye Week"}>({options.bye})</span>
  ) : null;

  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const base = parts.slice(1, 3).join("/");
  console.log("base", base);

  return (
    <>
      <Link to={`/player/${player.id}`}>
        {pos ? `${pos}-` : null}
        {name}
        {nfl ? `, ${nfl}` : null}
        {bye}
        {injury}
      </Link>
    </>
  );
}

export function getPlayerNameFull(player) {
  // return getPlayerName(player);

  if (!player) return null;
  return `${player.firstName} ${player.lastName}`;
}

export function getPlayerNameShort(player) {
  if (!player) return null;

  let nameShort;
  if (player.pos === "DEF") {
    nameShort =
      player.firstName === "Washington" ? player.firstName : player.lastName;
  } else {
    nameShort = player.firstName.charAt(0) + "." + player.lastName;
  }
  return nameShort;
}

export function getPosPlayerNameTeam(player) {
  // return getPlayerName(player, { pos: true, short: true, nfl: true });

  if (!player) return null;
  let name = `${player.pos}-${getPlayerNameShort(player)}`;
  if (player.pos !== "DEF")
    name += player.nflTeamAbbr
      ? ", " + NflUtil.formatNflTeamAbbr(player.nflTeamAbbr)
      : "";
  return name;
}

export function getPosPlayerFullNameTeam(player) {
  // return getPlayerName(player, { pos: true, nfl: true });

  if (!player) return null;
  let name = `${player.pos}-${getPlayerNameFull(player)}`;
  if (player.pos !== "DEF")
    name += player.nflTeamAbbr
      ? ", " + NflUtil.formatNflTeamAbbr(player.nflTeamAbbr)
      : "";
  return name;
}

export function getPlayerInjuryCross(player) {
  if (!player) return null;

  let injury = null;
  if (player.injuries) {
    let imgSrc = "injury-cross";
    let imgAlt = "injury cross";
    let isIR = false;

    let title = player.injuries
      .map(({ status, injury, info, updated, site }) => {
        if (status === "IR") isIR = true;
        let dateFormatted = updated ? " " + moment(updated).format("ll") : "";
        return `${status} - ${injury} - ${info} (${site}${dateFormatted})`;
      })
      .join("\n");

    if (isIR) {
      imgSrc = "ir";
      imgAlt = "injured reserve";
    }

    injury = (
      <img
        title={title}
        src={`/img/icons/${imgSrc}.gif`}
        alt={imgAlt}
        style={{ paddingLeft: "0.2rem" }}
      />
    );
  }

  return injury;
}

export function PlayerNameShort({ player }) {
  if (!player) return null;
  return (
    <span title={getPlayerNameFull(player)}>{getPlayerNameShort(player)}</span>
  );
}

export function PlayerNameShortInjury({ player }) {
  if (!player) return null;

  let injury = getPlayerInjuryCross(player);

  return (
    <>
      <span title={getPlayerNameFull(player)}>
        {getPlayerNameShort(player)}
      </span>
      {injury}
    </>
  );
}

export function PlayerNameFullInjury({ player }) {
  if (!player) return null;

  let injury = getPlayerInjuryCross(player);

  return (
    <span>
      {getPlayerNameFull(player)}
      {injury}
    </span>
  );
}

export function PosPlayerNameTeam({ player }) {
  if (!player) return null;
  const name = getPosPlayerNameTeam(player);

  return <span title={getPlayerNameFull(player)}>{name}</span>;
}
